import React from "react";

const SERVICE_META = {
  customer_support: {
    name: "Whatsapp Chat Support",
    description: "AI-powered support agent that handles customer queries via chat and messaging channels.",
    icon: (
      <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.7}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z" />
      </svg>
    ),
  },
  document_rag: {
    name: "AI Knowledge Assistant",
    description: "AI answers questions using your uploaded documents for intelligent Q&A.",
    icon: (
      <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.7}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
      </svg>
    ),
  },
  voice_support: {
    name: "Voice AI Assistant",
    description: "Ask questions by voice and get answers from your uploaded documents.",
    icon: (
      <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.7}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
      </svg>
    ),
  },
  // appointment_booking: {
  //   name: "Appointment Booking",
  //   description: "Automated scheduling and appointment booking agent integrated with calendar systems.",
  //   icon: (
  //     <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.7}>
  //       <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z" />
  //     </svg>
  //   ),
  // },
};

const FALLBACK_META = {
  name: null,
  description: "Service integration for this business. Enable or disable access as required.",
  icon: (
    <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.7}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
    </svg>
  ),
};

const formatField = (field) => {
  if (!field) return "";
  if (typeof field === "string") return field.replace(/_/g, " ");
  if (typeof field === "object") {
    const name = field.field || field.name || field.key || "field";
    const message = field.message || field.reason || field.error;
    return message ? `${name.replace(/_/g, " ")}: ${message}` : name.replace(/_/g, " ");
  }
  return String(field);
};

const FieldList = ({ title, fields }) => {
  if (!fields?.length) return null;

  return (
    <div>
      <p className="text-xs font-semibold text-rose-700">{title}</p>
      <ul className="mt-1 list-disc space-y-1 pl-4 text-xs text-rose-700">
        {fields.map((field, index) => (
          <li key={`${title}-${index}`}>{formatField(field)}</li>
        ))}
      </ul>
    </div>
  );
};

const WhatsAppReadinessMessage = ({ readiness, error }) => {
  const missingFields = readiness?.missing_fields || readiness?.validation?.missing_fields || [];
  const invalidFields = readiness?.invalid_fields || readiness?.validation?.invalid_fields || [];
  const canStartSignup = readiness?.actions?.can_start_signup !== undefined
    ? readiness.actions.can_start_signup
    : !!readiness?.ready;

  if (!error && (!readiness || (readiness.ready && canStartSignup))) return null;

  return (
    <div className="mt-4 rounded-xl border border-rose-200 bg-rose-50 px-4 py-3">
      <p className="text-xs font-semibold text-rose-800">
        {error || "WhatsApp setup needs business details before it can start."}
      </p>
      <div className="mt-2 space-y-2">
        <FieldList title="Missing fields" fields={missingFields} />
        <FieldList title="Invalid fields" fields={invalidFields} />
      </div>
    </div>
  );
};

const WhatsAppSessionMessage = ({ session, signupResult, accountProgress, isAccountConnected }) => {
  if (isAccountConnected || (!session && !signupResult?.event && !accountProgress)) return null;

  const expiresAt = session?.expires_at ? new Date(session.expires_at) : null;
  const expiryLabel = expiresAt && Number.isFinite(expiresAt.getTime()) ? expiresAt.toLocaleString() : null;
  const outcomeMessages = {
    cancelled: "Meta signup was cancelled. Start setup again when ready.",
    popup_closed: "Meta signup window was closed before completion.",
    error: "Meta signup could not be completed. Please retry.",
    session_expired: "WhatsApp setup session timed out. Start again or try again.",
  };

  return (
    <div className="mt-4 rounded-xl border border-sky-200 bg-sky-50 px-4 py-3">
      {session ? (
        <p className="text-xs font-semibold text-sky-800">
          WhatsApp setup session started{expiryLabel ? `, expires ${expiryLabel}` : "."}
        </p>
      ) : null}
      {signupResult?.event === "completed" ? (
        <p className="mt-2 text-xs text-sky-700">
          Meta signup returned onboarding data and the completion request was sent to DocLift.
        </p>
      ) : null}
      {outcomeMessages[signupResult?.event] ? (
        <p className="mt-2 text-xs text-sky-700">{outcomeMessages[signupResult.event]}</p>
      ) : null}
      {accountProgress ? (
        <div className="mt-2 space-y-1 text-xs text-sky-700">
          <p>
            Account status: <span className="font-semibold">{accountProgress.status || "connecting"}</span>
          </p>
          <p>
            Stage: <span className="font-semibold">{accountProgress.stage || "authorization_received"}</span>
          </p>
          {accountProgress.message ? <p>{accountProgress.message}</p> : null}
        </div>
      ) : null}
    </div>
  );
};

const ServiceToggleCard = ({
  service,
  onToggle,
  onConnectWhatsApp,
  onForceRestartWhatsApp,
  whatsAppReadiness,
  whatsAppReadinessError,
  whatsAppOnboardingSession,
  whatsAppSignupResult,
  whatsAppAccountProgress,
  checkingWhatsAppReadiness,
  disabled,
  accountStatus,
}) => {
  const meta = SERVICE_META[service.service_key] || FALLBACK_META;
  const displayName = meta.name || service.service_key;
  const isWhatsAppSignupService = service.service_key === "customer_support";
  
  const isAccountConnected = isWhatsAppSignupService && accountStatus?.status === "connected";
  const isEnabled = service.status === "enabled" || isAccountConnected;
  const showStatusLabel = isWhatsAppSignupService && (!isEnabled || isAccountConnected);

  const handleToggleClick = () => {
    if (isWhatsAppSignupService && !isEnabled) {
      onConnectWhatsApp?.();
      return;
    }

    onToggle(service);
  };

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-start gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#eef5ff] text-[#096dea]">
            {meta.icon}
          </div>
          <div>
            <div className="flex flex-wrap items-center gap-2">
              <h4 className="text-sm font-semibold text-slate-950">{displayName}</h4>
              {showStatusLabel ? (
                <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ring-inset ${
                  isAccountConnected 
                    ? "bg-green-100 text-green-700 ring-green-200" 
                    : "bg-slate-100 text-slate-700 ring-slate-200"
                }`}>
                  {isAccountConnected ? "complete" : checkingWhatsAppReadiness ? "checking..." : "pending"}
                </span>
              ) : null}
            </div>
            <p className="mt-1 text-xs leading-relaxed text-slate-500">{meta.description}</p>
          </div>
        </div>
        <button
          type="button"
          disabled={disabled || (isWhatsAppSignupService && checkingWhatsAppReadiness)}
          onClick={handleToggleClick}
          className={`relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full transition-colors duration-200 disabled:cursor-not-allowed disabled:opacity-50 ${
            isEnabled ? "bg-[#096dea]" : "bg-slate-300"
          }`}
          role="switch"
          aria-checked={isEnabled}
          aria-label={`${displayName} ${showStatusLabel && !isAccountConnected ? "Start WhatsApp Setup" : "toggle"}`}
        >
          <span
            className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-sm ring-0 transition-transform duration-200 ${
              isEnabled ? "translate-x-[22px]" : "translate-x-[2px]"
            }`}
          />
        </button>
      </div>
      {isWhatsAppSignupService ? (
        <>
          <WhatsAppReadinessMessage readiness={whatsAppReadiness} error={whatsAppReadinessError} />
          <WhatsAppSessionMessage
            session={whatsAppOnboardingSession}
            signupResult={whatsAppSignupResult}
            accountProgress={whatsAppAccountProgress}
            isAccountConnected={isAccountConnected}
          />
          {!isAccountConnected && (whatsAppReadinessError || whatsAppSignupResult || accountStatus?.has_active_session) ? (
            <div className="mt-3 text-right">
              <button
                type="button"
                onClick={onForceRestartWhatsApp}
                disabled={checkingWhatsAppReadiness}
                className="text-xs font-semibold text-slate-500 hover:text-slate-800 disabled:cursor-not-allowed disabled:opacity-50 underline decoration-slate-300 underline-offset-4"
              >
                Having trouble? Force Restart Setup
              </button>
            </div>
          ) : null}
          {isEnabled && (
            <div className="mt-4 flex items-center gap-3 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm font-medium text-emerald-800">
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-600">
                <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </span>
              WhatsApp chat support is activated and enabled.
            </div>
          )}
        </>
      ) : null}
    </div>
  );
};

export default ServiceToggleCard;
